import { motion } from "framer-motion";

// Simple reusable scroll-reveal wrapper.
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "", light = false }) => (
  <span
    className={`overline inline-block ${
      light ? "text-[#B87333]" : "text-[#B87333]"
    } ${className}`}
  >
    {children}
  </span>
);

export default Reveal;
